import requestor from "shared/service/requestor";

export default class StudentApi {
  all = ({ courseId, lessonId }) =>
    requestor.get("/course/student_all", {
      course_id: courseId,
      lesson_id: lessonId,
    });

  one = ({ courseId, lessonId }, clientId) =>
    requestor.get("/course/student_one", {
      course_id: courseId,
      lesson_id: lessonId,
      client_id: clientId,
    });

  invite = ({ courseId, lessonId }, groupId, notify, students) =>
    requestor.put("/course/student_invite", {
      course_id: courseId,
      lesson_id: lessonId,
      group_id: groupId,
      notify: notify,
      students: students,
    });

  delete = ({ courseId, lessonId }, studentId) =>
    requestor.delete("/course/student_delete", {
      course_id: courseId,
      lesson_id: lessonId,
      ids: [studentId],
    });

  deleteMultiple = ({ courseId, lessonId }, studentIds) =>
    requestor.delete("/course/student_delete_multiple", {
      course_id: courseId,
      lesson_id: lessonId,
      ids: studentIds,
    });

  bulkMove = ({ courseId, lessonId }, groupId, move, all, clientIds) =>
    requestor.put("/course/student_bulk_move", {
      course_id: courseId,
      lesson_id: lessonId,
      group_id: groupId,
      move: move,
      all: all,
      client_ids: clientIds,
    });
}
